import PropTypes from 'prop-types'
import React, { Component } from 'react'
import {
    Button,
    Container,
    Divider,
    Grid,
    Header,
    Icon,
    Image,
    List,
    Menu,
    Responsive,
    Segment,
    Sidebar,
    Visibility,
} from 'semantic-ui-react'

import { Link } from '@reach/router';
import ResponsiveContainer from 'components/layout/PageComponents';

const HomepageLayout = (props) => (
    <ResponsiveContainer height={100} currentPage="about">
        <Segment style={{ padding: '3em 0em' }} vertical>
            <Grid container stackable verticalAlign='middle'>
                <Grid.Row>
                    <Grid.Column width={16}>
                        <Header as='h2' style={{ fontSize: '3em' }}>
                            Malaysia Future Flood Explorer
                        </Header>
                       
                        <p style={{ fontSize: '1.1em' }}>
                        Malaysia faces challenges flood related challenges. These include climate change and a diversity of settings (from the urban centres of Kuala Lumpur to the rural coastal floodplains and the mountain areas.
                        </p>

                        <p style={{ fontSize: '1.1em' }}>
                        Flooding is central to Malaysia’s story; both intense rainfall (pluvial) floods that as well as longer duration fluvial flooding and coastal floods. This tool presents an innovative assessment approach that brings together earth observation and in-situ data and findings from local studies and national scale climate and hydrological response modelling with hydraulic and the risk analysis (that accounts for existing and future adaptation measures). The analysis provides a credible large-scale assessment of present flood hazards (short duration and longer duration floods) and socio-economic impacts. Future projections of climate change and spatially explicit projections of socio-economic development are used alongside user definable adaptation strategies. Future risks can then be explored by the user at a range of scales from national, state and more local scales.
                        </p>

                        <Header as='h3' style={{ fontSize: '2em' }}>
                            Provenance and further reading
                        </Header>
                        <p style={{ fontSize: '1.1em' }}>
                            The FFE was first used to inform the UK Climate Change Risk Assessment in 2015 (Sayers et
                            al, 2016).  Since that first application the FFE has been future developed to include
                            refinements assessment of social vulnerability and a wider range of risk metrics and the
                            development of refined defence adaptation representation.   Multiple reports and papers
                            have been published, including: </p>

                        <ul>
                            <li>Sayers P.B, Brisley R, Wingfield S, Warren S, Mattingley, P, Robinson, P. Horritt, M and Lamb, R. &nbsp;
                                <a href="www.sayersandpartners.co.uk/uploads/6/2/0/9/6209349/2018_sayers_et_al_national_infrastructure_assessment_report.pdf" target="_blank">
                                    A national analytics toolset to support an exploration of alternative investments in flood
                                    risk management infrastructure</a>,<br /> A report for the National
                                Infrastructure Commission by JBA and Sayers and Partners.
                            </li>

                            <li>Sayers PB and Smith A (2018). &nbsp;
                                <a href="http://www.sayersandpartners.co.uk/uploads/6/2/0/9/6209349/2018_sayers_and_smith_-_sustainable_water_infrastructure_in_africa_-_final_v4.0.pdf" target="_blank">
                                    Can Africa take the lead on Sustainable Water Infrastructure?</a><br /> Report prepared for the African Development Bank</li>

                            <li>
                                Sayers, P., Penning-Rowsell, E., Horritt, M. (2017). &nbsp;
                                <a href="https://link.springer.com/epdf/10.1007/s10113-017-1252-z?author_access_token=5yLB11VZsw48APtN1RCVvPe4RwlQNchNByi7wbcMAY7ojCvRGpcd8-s3tRBzhSr_xLoWoOPraOuC1tNtpMXE8FkUBUUvMrwStMFAneCQ94ZMkp90naKry9vATIgeoLRbBFNy07JRUwVcH9BqSmXo1g%3D%3D" target="_blank">
                                    Flood vulnerability, risk and social disadvantage: Current and future patterns in the UK.
                                </a>
                                Journal of Regional Environmental Change.  DOI https://doi.org/10.1007/s10113-017-1252-z

                            </li>

                            <li>
                                ​Sayers et al (2016) &nbsp;
                                <a href="http://www.e3s-conferences.org/component/makeref/?task=show&type=html&doi=10.1051/e3sconf/20160711004" target="_blank">
                                    Believe it or not? The challenge of validating large scale probabilistic risk models.
                                </a>
                                Proceedings of Floodrisk2016 &nbsp;
                                Paul Sayers, Rob Lamb, Mike Panzeri, Hayley Bowman, Jim Hall, Matt Horritt and Edmund Penning-Rowsell
                                E3S Web Conf., 7 (2016) 11004 DOI: http://dx.doi.org/10.1051/e3sconf/20160711004
                            </li>

                            <li>
                                Sayers et al (2016) &nbsp;
                                <a href="http://www.e3s-conferences.org/articles/e3sconf/abs/2016/02/e3sconf_flood2016_21005/e3sconf_flood2016_21005.html" target="_blank">
                                    The analysis of future flood risk in the UK using the Future Flood Explorer (FFE).
                                </a>
                                Proceedings of Floodrisk2016.
                                Paul Sayers, Matt Horritt, Edmund Penning-Rowsell, Andrew McKenzie and David Thompson. E3S Web Conf., 7 (2016) 21005
                                DOI: http://dx.doi.org/10.1051/e3sconf/20160721005
                            </li>

                        </ul>








                        <Header as='h3' style={{ fontSize: '2em' }}>
                            Technology used
                        </Header>
                        <p style={{ fontSize: '1.1em' }}>
                        The assessment of flood risk is based on a combination of in-situ and earth observation data, physical process and socio-economic models embedded with a probabilistic risk assessment provided by through the Future Flood Explorer (FFE). The FFE uses information on flood hazards (developed by Sayers and Partners), information on future land use and growth (from UK CEH), climate change impacts on fluvial flows (from UKCEH), future sea level rise impacts on coastal flooding (from Sayers) and changes in short duration rainfall (and associated flooding) (from Sayers).    Adaptation measures and the economic damages functions developed with UDP and UKCEH.
                        </p>
                        <p style={{ fontSize: '1.1em' }}>
                        The future scenarios have been developed as part of the consortium processes.
                        </p>
                    </Grid.Column>
                </Grid.Row>
            </Grid>

            <Container text>
                <Divider
                    as='h4'
                    className='header'
                    horizontal
                    style={{ marginTop: '7em', marginBottom: '3em', textTransform: 'uppercase' }}
                >
                    <a href='#'>Partners</a>
                </Divider>
                <p style={{ fontSize: '1.33em' }}>
                This dashboard has been developed with funding support from the UK Newton funds and national Malaysia
                funding bodies that include:
                </p>

                <Grid container stackable verticalAlign='middle' textAlign='center'>
                    <Grid.Row>
                        <Grid.Column width={4}>
                            <Image src="/assets/images/logos/ministry_of_higher_education.png" height="80px" />
                        </Grid.Column>
                        <Grid.Column width={4}>
                            <Image src="/assets/images/logos/newton-ungku-omar-master-website.jpg" />
                        </Grid.Column>
                        <Grid.Column width={4}>
                            <Image src="/assets/images/logos/ESRC logo.png" />
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row>
                        <Grid.Column width={4}>
                            <Image src="/assets/images/logos/NERC logo.png" />
                        </Grid.Column>
                        <Grid.Column width={4}>
                            <Image src="/assets/images/logos/sayers-and-partners.png" />
                        </Grid.Column>
                        <Grid.Column width={4}>
                            <Image src="/assets/images/logos/ceh.png" />
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row>
                        <Grid.Column width={4}>
                            <Image src="/assets/images/logos/logoupm.png" />
                        </Grid.Column>
                        <Grid.Column width={4}>
                            <Image src="/assets/images/logos/logouum-small.png" />
                        </Grid.Column>
                        <Grid.Column width={4}>
                            <Image src="/assets/images/logos/LogoUKMWatan.png" />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>

            </Container>
        </Segment>
        <Segment inverted vertical style={{ padding: '5em 0em' }}>
            <Container>
                <Grid divided inverted stackable>
                    <Grid.Row>
                        <Grid.Column width={3} />
                        <Grid.Column width={3}>
                            <Header inverted as='h4' content='About' />
                            <List link inverted>
                                <List.Item as='a'>Sitemap</List.Item>
                                <List.Item as='a' href="http://http://www.sayersandpartners.co.uk/contact-us.html">Contact Us</List.Item>
                            </List>
                        </Grid.Column>
                        <Grid.Column width={7}>
                            <Header as='h4' inverted>
                                Malaysia future flood explorer
                            </Header>
                            <p>
                            A probabilistic assessment of flood risks from all sources across the Malaysian Peninsular today and in the future
                            </p>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Container>
        </Segment>
    </ResponsiveContainer>
)
export default HomepageLayout